import Loading from "components/Loading";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from 'react'
import queryString from 'utils/queryString';
import { getWithdraw } from "services/withdraw.routes";
import InfiniteScroll from "react-infinite-scroll-component";
import WithdrawTransactionsTable from "./WithdrawTransactionsTable";

export default function WithdrawTransactions() {
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [withdraw, setWithdraw] = useState([]);
    const [trigger, setTrigger] = useState(null);
    const [searchInfo, setSearchInfo] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        setSearchInfo({ ...searchInfo, [name]: value });
    };

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            per_page: 20,
            status: searchInfo.status || null,
        };
        getWithdraw(queryString(query), trigger !== null, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
            }
            if (page !== 0) {
                setWithdraw((prev) => [...prev, ...data.data]);
            } else {
                setWithdraw(data.data);
            }
            setLoading(false);
            setCursor(data?.meta?.next_cursor === null ? "" : data?.meta?.next_cursor);
            setHasMore(data?.meta?.next_cursor !== null);
        });
    }, [page, trigger]);

    const onFilterClick = () => {
        setPage(0);
        setCursor('');
        setTrigger(Math.random());
    }
    const onClearFilterClick = () => {
        setSearchInfo({})
        onFilterClick()
    }

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={withdraw.length} next={fetchMoreData} hasMore={hasMore}>
                <WithdrawTransactionsTable data={withdraw} setWithdraw={setWithdraw} filterInfo={searchInfo} handleFilterChange={handleChange} onFilterClick={onFilterClick} onClearFilterClick={onClearFilterClick} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
